import styled from "styled-components"
import {Grid} from "react-bootstrap"

import Card from "@irati/ui/src/Layout/Card"
import {spacingCss, SpacingProps} from "@irati/ui/src/global/css"

const FIXED_HEIGHT = "200px"

interface StyledProps extends SpacingProps {
  fixedHeight?: boolean
}

export const RightCard = styled(Card)<StyledProps>`
  ${({fixedHeight}) => fixedHeight && `height: ${FIXED_HEIGHT};`}
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    padding: 0;
  `}
  ${spacingCss}
`

export const LeftCard = styled(Card)<StyledProps>`
  flex-grow: 1;
  ${({fixedHeight}) => fixedHeight && `height: ${FIXED_HEIGHT};`}
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    padding: 0;
  `}
  ${spacingCss}
`

export const StyledGrid = styled(Grid)`
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    width: auto;
  `}
`
